<template>
    <div style="width:100%; height: 100%; background-image: url('/img/bgd-banner.jpg')">
        <v-container>
            <v-card>
                <v-card-title dark class="white--text" style="background-color:#00aeef">
                    Register
                </v-card-title>
                <form>
                    <v-layout row wrap pt-4 px-10>
                        <v-flex xs12>
                            <v-text-field readonly disabled v-model="email" label="Email"></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="firstName"
                                label="First Name"
                                :counter="50"
                                :error-messages="errors.collect('firstName')"
                                v-validate="'required|alpha_spaces|max:50'"
                                data-vv-name="firstName"
                                class="requires--text"
                                data-cy="txtFirstName"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="lastName"
                                label="Last Name"
                                :counter="50"
                                :error-messages="errors.collect('lastName')"
                                v-validate="'required|alpha_spaces|max:50'"
                                data-vv-name="lastName"
                                class="requires--text"
                                data-cy="txtLastName"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="password"
                                label="Password"
                                type="password"
                                :counter="50"
                                :error-messages="errors.collect('Password')"
                                v-validate="'required|max:50|min:8'"
                                data-vv-name="Password"
                                class="requires--text"
                                data-cy="txtPassword"
                                ref="mainPassword"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                v-model="passwordReenter"
                                label="Re-Enter Password"
                                type="password"
                                :counter="50"
                                :error-messages="errors.collect('PasswordReEnter')"
                                v-validate="'required|confirmed:mainPassword'"
                                data-vv-name="PasswordReEnter"
                                data-vv-as="Re-Enter Password"
                                data-cy="txtPasswordReEnter"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex class="text-xs-center" my-4>
                            <v-btn
                                color="hubblue"
                                class="white--text"
                                @click="save"
                                :loading="loading"
                                :disabled="loading"
                                data-cy="btnRegister"
                                >Register</v-btn
                            >
                        </v-flex>
                    </v-layout>
                </form>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'
import { scrypt } from 'crypto'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,
            snackbar: false,
            snackbarMessage: null,
            snackbarContext: '',
            email: null,
            firstName: null,
            lastName: null,
            oldPassword: null,
            password: null,
            passwordReenter: null
        }
    },

    methods: {
        createUser() {
            this.loading = true
            const app = this
            let snackbarParams

            let params = {
                firstName: app.firstName,
                lastName: app.lastName,
                oldPassword: app.oldPassword,
                newPassword: app.password
            }
            axios
                .patch(this.$store.state.userUrl + '/registerinvite/' + app.userId, {
                    params: params
                })
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    this.$router.push({ name: 'Login' })
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        save() {
            this.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        this.createUser()
                    }
                })
                .catch(() => {
                    return false
                })
        }
    },
    created() {
        if (this.$route.query.uid && this.$route.query.ah && this.$route.query.email) {
            this.userId = this.$route.query.uid
            this.oldPassword = this.$route.query.ah
            this.email = this.$route.query.email
        } else {
            this.$router.push({ name: 'Login' })
        }
    }
}
</script>
